import { translate } from 'loankeeper-common/helpers'

export default (key) => translate(`frm_client_ind-${key}`)
export const translateOrg = (key) => translate(`frm_client_org-${key}`)
export const translateLKMessage = (key) => translate(`LKMESSAGE-${key}`)
export const translateWebMessage = (key) => translate(`frm_web_messages-${key}`)
